export const LINKS = {
  business: "https://form.jotform.com/afariinnovators/business-on-boarding",
  realEstate: "https://apply.afariinnovatorsllc.com/financing",
  advisor: "https://calendly.com/founder-afariinnovatorsllc",
  ncnd: "https://form.jotform.com/afariinnovators/afari--mutual-ncnd",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
